import script from "./JobDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetails.vue?vue&type=script&setup=true&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=44815c1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44815c1c"]])

export default __exports__